import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';

@Component({
  selector: 'td-wb-call-out-header',
  templateUrl: './call-out-header.component.html',
  styleUrls: ['./call-out-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CallOutHeaderComponent {
  ariaLevel: InputSignal<string | undefined> = input<string | undefined>(undefined, { alias: 'aria-level' });
}
